const registeredIntervals = []

const DELAY = 14;

export const runPlannedActions = () => {
    const lastRunToExecute = performance.now() - DELAY
    for (const interval of registeredIntervals) {
        if (interval.lastRun <= lastRunToExecute) {
            interval.callback()
            interval.lastRun = performance.now()
        }
    }
}

export const useInterval = (callback) => {
    registeredIntervals.push({
        callback,
        lastRun: 0,
    })
}